$( document ).ready(function() {
    $('.bannersliderinfo_container').owlCarousel({
        loop: true,
        autoplay: true,
        autoplayTimeout: 7000,
        nav: true,
        dots: true,
        items: 1,
    })
});

